import { useQuery } from "@tanstack/react-query";
import { ProjectResponse } from "../../../types";
import { getProjectsApi } from "../../../api/resources.api";

export const useProjects = (page: number = 1) => {
  return useQuery<ProjectResponse, Error>({
    queryKey: ["projects", page],

    queryFn: async () => {
      const response: ProjectResponse = await getProjectsApi({ page });

      if (!response?.status || !Array.isArray(response.data)) {
        throw new Error("Invalid Projects data format");
      }

      return response;
    },

    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
